// Vokelle yasal metinleri (VokerStudio) — hukukçu onaylı Psikovoke metinlerinden
// Vokelle hizmetine uyarlanmıştır. İletişim: info@vokelle.com
// Bu metinler Türkçe'dir; arayüz dili İngilizce olsa da yasal içerik değişmez.

const CONTACT = 'VokerStudio — info@vokelle.com — https://vokelle.com';
const UPDATED = '07.09.2026';

export const LEGAL_SLUGS = ['gizlilik-politikasi', 'kullanim-kosullari', 'kvkk'];

export const LEGAL = {
  'gizlilik-politikasi': {
    title: 'Gizlilik Politikası',
    updated: UPDATED,
    intro:
      'Bu Gizlilik Politikası, VokerStudio tarafından işletilen Vokelle hizmetinin kullanıcı kişisel verilerini nasıl topladığını, kullandığını, sakladığını ve koruduğunu açıklar.',
    sections: [
      {
        h: '1. Genel',
        p: [
          'Vokelle; private server sahiplerine, sunucularının ekonomisini ve oyuncu aktivitesini izleyen, olağandışı durumları tespit edip bildiren bir yazılım hizmetidir (SaaS). Hizmeti kullanmak için oluşturduğunuz hesap kapsamında bazı kişisel verileriniz işlenir.',
        ],
      },
      {
        h: '2. Toplanan Veriler',
        p: ['Vokelle aşağıdaki verileri işleyebilir:'],
        list: [
          'Hesap bilgileri: e-posta adresiniz, şifreniz (yalnızca şifrelenmiş/özet biçimde saklanır) ve isteğe bağlı görünen adınız.',
          'Ödeme bilgileri: ödemeler lisanslı bir ödeme kuruluşunun altyapısı üzerinden alınır. Kart numaranız Vokelle sunucularına hiçbir zaman ulaşmaz; yalnızca ödeme kuruluşu tarafından üretilen ve Vokelle\'nin göremediği bir "kart saklama anahtarı" (isteğe bağlı, otomatik yenileme için) tutulabilir.',
          'Kullanım ve güvenlik bilgileri: giriş tarih/saati, IP adresi ve tarayıcı bilgisi (dolandırıcılık önleme ve güvenlik amaçlı).',
          'Bildirim kanalı bilgileri: alarm almak için kendi eklediğiniz Discord webhook adresi, e-posta adresi veya Telegram sohbet kimliği.',
          'Ajan verileri: Vokelle ajanı, oyun sunucunuzdaki veritabanını yalnızca OKUR ve Vokelle\'ye yalnızca toplu, sayısal göstergeler gönderir (ör. "son bir saatte üretilen item sayısı", "aktif oyuncu sayısı", "toplam altın miktarı"). Oyuncu adları, şifreler, e-posta adresleri, sohbet içerikleri ve bireysel işlem kayıtları Vokelle\'ye HİÇBİR ZAMAN aktarılmaz; sunucunuzun dışına çıkmaz.',
        ],
      },
      {
        h: '3. Verilerin Kullanımı',
        p: ['Toplanan kişisel veriler şu amaçlarla kullanılabilir:'],
        list: [
          'Hizmetin sunulması, sürdürülmesi ve iyileştirilmesi',
          'Anomali tespiti ve size bildirim gönderilmesi',
          'Hesap ve abonelik yönetimi, ödeme işlemleri',
          'Teknik destek sağlanması',
          'Güvenliğin sağlanması, kötüye kullanımın önlenmesi',
          'Yasal yükümlülüklerin yerine getirilmesi',
        ],
      },
      {
        h: '4. Verilerin Saklanması',
        p: [
          'Kişisel veriler yalnızca bu Politikada belirtilen amaçlar için gerekli olduğu süre boyunca saklanır. Hesabınızı kapatmanız veya aboneliğinizin sona ermesi hâlinde verileriniz makul bir süre içinde silinir veya anonim hâle getirilir. Ödeme ve fatura kayıtları, vergi ve ticaret mevzuatı gereği öngörülen süre boyunca saklanır.',
        ],
      },
      {
        h: '5. Üçüncü Taraflarla Paylaşım',
        p: [
          'Kişisel verileriniz kural olarak üçüncü taraflarla paylaşılmaz. Sınırlı istisnalar şunlardır:',
        ],
        list: [
          'Ödeme altyapısı sağlayıcımız — ödeme işlemlerinin gerçekleştirilmesi için',
          'E-posta gönderimi ve sunucu barındırma (hosting) hizmeti sağlayıcıları — hizmetin teknik olarak sunulması için',
          'Yetkili kamu kurum ve kuruluşları — hukuka uygun bir talep bulunması hâlinde',
          'Kendi eklediğiniz bildirim kanalları (Discord, Telegram, e-posta) — alarm özetleri yalnızca sizin tercih ettiğiniz bu kanallara iletilir',
          'Web analitiği hizmeti sağlayıcımız — site trafiğinin toplu ve çerezsiz ölçümü için',
        ],
      },
      {
        h: '6. Çerezler ve İzleme',
        p: [
          'Vokelle pazarlama veya profilleme amaçlı çerez kullanmaz. Site trafiğini toplu ve anonim olarak ölçmek için çerezsiz bir web analitiği aracı kullanılır; bu araç tarayıcınızda çerez veya kalıcı bir kimlik saklamaz, yalnızca sayfa görüntüleme sayısı, yaklaşık konum (ülke/şehir düzeyinde), cihaz türü ve yönlendiren adres gibi toplu istatistikler üretir. Sizi kişisel olarak tanımlayan bir veri toplanmaz. Ayrıca oturumunuzu açık tutmak için gerekli teknik tarayıcı depolaması (localStorage) kullanılır.',
        ],
      },
      {
        h: '7. Kullanıcı Hakları',
        p: [
          'KVKK m.11 kapsamında; verilerinize erişme, düzeltilmesini isteme, silinmesini talep etme, işlenmesine itiraz etme ve taşınabilirlik haklarına sahipsiniz. Talepleriniz için info@vokelle.com adresine yazabilirsiniz.',
        ],
      },
      {
        h: '8. Veri Güvenliği',
        p: [
          'Şifreler geri döndürülemez biçimde özetlenerek (hash) saklanır, tüm bağlantılar şifrelidir (HTTPS) ve Vokelle ajanı oyun veritabanınıza yalnızca salt-okunur bir kullanıcıyla bağlanır. Verilerinize yetkisiz erişimi önlemek için makul teknik ve idari tedbirler alınır.',
        ],
      },
      {
        h: '9. Politikadaki Değişiklikler',
        p: [
          'Bu Gizlilik Politikası zaman zaman güncellenebilir. Güncel sürüm her zaman bu sayfada yayımlanır; önemli değişiklikler ayrıca bildirilir.',
        ],
      },
      {
        h: '10. Reklam Performans Ölçümü (İsteğe Bağlı)',
        p: [
          'Sunucu sahibi, Vokelle panelinden "Reklam ölçümü" özelliğini kendi isteğiyle etkinleştirebilir. Bu özellik varsayılan olarak KAPALIDIR ve istendiği zaman kapatılabilir.',
          'Özellik etkinken, sunucuya yeni kaydolan oyun hesaplarının kayıt anındaki IP adresi, Vokelle ajanı tarafından geri döndürülemez biçimde şifrelenerek (SHA-256 hash) işlenir. Ham (açık) IP adresi hiçbir aşamada saklanmaz ve VokerStudio sistemlerine aktarılmaz. Bu hash değeri yalnızca, sunucu sahibinin oluşturduğu reklam kampanyası bağlantılarına (vokelle.com/r/...) gelen tıklamalarla istatistiksel eşleştirme yapmak — yani bir reklamın kaç yeni kayıt getirdiğini tahmin etmek — için kullanılır.',
          'Dönüşüm pikseli (isteğe bağlı): sunucu sahibi, kendi web sitesine küçük bir ölçüm kodu ekleyebilir. Bu kod, ziyaretçinin tarayıcısında yalnızca sunucu sahibinin kendi alan adında birinci-taraf bir kayıt (localStorage) tutar; Vokelle çerezi kullanılmaz, farklı siteler arası takip yapılmaz. Ziyaretçi kaydolduğunda, sunucu sahibi tarafından oluşturulan oyun kullanıcı adı ve ilgili kampanya kimliği Vokelle\'ye iletilir. Kredi kartı, e-posta, şifre veya başka bir kişisel veri işlenmez.',
          '"Reklam ölçümü" açıkken, atıf yapılan bu kullanıcı adlarına ait hesapların yalnızca toplam gerçek-para bakiye/harcama tutarı (oyun-içi "cash" değeri) ajan tarafından okunur ve reklam yatırımının geri dönüşünü (ROAS) hesaplamak için kullanılır. Bireysel satın alma kalemleri, ödeme yöntemi veya oyuncu kimliği işlenmez.',
          'Bu kapsamda işlenen veriler en geç 90 gün içinde otomatik olarak silinir. Sonuçlar yalnızca toplu/sayısal biçimde (ör. "bu kampanyadan tahmini 42 kayıt, ~₺18.000 gelir") sunucu sahibine gösterilir; tekil oyunculara ilişkin bir profil oluşturulmaz.',
        ],
      },
      {
        h: '11. Yasal Yükümlülükler',
        p: [
          '5651 sayılı İnternet Ortamında Yapılan Yayınların Düzenlenmesi ve Bu Yayınlar Yoluyla İşlenen Suçlarla Mücadele Edilmesi Hakkında Kanun uyarınca işlem tarih ve saati ile IP adresi bilgileri yasal süreler boyunca saklanır. 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında paylaştığınız veriler, yasal olarak gerekli süreler boyunca muhafaza edilir.',
        ],
      },
      {
        h: '12. Kişisel Verilerin İşlenme Şartları',
        p: [
          'Verileriniz KVKK m.5 kapsamında; bir sözleşmenin kurulması veya ifası için gerekli olması, hukuki yükümlülüğün yerine getirilmesi, bir hakkın tesisi/kullanılması/korunması ve veri sorumlusunun meşru menfaati hukuki sebeplerine dayanılarak; bunların dışındaki hâllerde açık rızanıza dayanılarak işlenir. Veriler Türkiye\'de bulunan sistemlerde saklanır.',
        ],
      },
      {
        h: '13. Uyuşmazlıklar ve İletişim',
        p: [
          'Bu Gizlilik Politikasından doğan uyuşmazlıklarda Türk hukuku uygulanır; İstanbul (Anadolu) mahkemeleri ve icra daireleri yetkilidir.',
          `İletişim: ${CONTACT}`,
        ],
      },
    ],
  },

  'kullanim-kosullari': {
    title: 'Kullanım Koşulları',
    updated: UPDATED,
    intro:
      'Bu Kullanım Koşulları, VokerStudio tarafından sunulan Vokelle hizmetini kullanan gerçek veya tüzel kişiler ("Kullanıcı") ile VokerStudio arasındaki ilişkiyi düzenler. Hizmeti kullanarak bu koşulları kabul etmiş sayılırsınız.',
    sections: [
      {
        h: '1. Hizmetin Tanımı',
        p: [
          'Vokelle; Kullanıcının oyun sunucusu veritabanını salt-okunur bir ajan aracılığıyla izleyen, ekonomi ve oyuncu aktivitesi göstergelerini toplayıp olağandışı durumları tespit eden ve Kullanıcıya bildiren bir yazılım hizmetidir. Hizmet "olduğu gibi" ve "erişilebilir olduğu ölçüde" sunulur.',
        ],
      },
      {
        h: '2. Hesap',
        p: [
          'Kullanıcı, kayıt sırasında doğru ve güncel bilgi vermekle yükümlüdür. Hesap şifresinin ve lisans anahtarının gizliliği Kullanıcının sorumluluğundadır. Her lisans anahtarı tek bir sunucuya bağlıdır ve üçüncü kişilerle paylaşılamaz.',
        ],
      },
      {
        h: '3. Abonelik, Ücret ve Yenileme',
        p: [
          'Hizmet, seçilen abonelik dönemi için geçerlidir ve ücretleri web sitesinde belirtilen tutarlardadır. Ödemeler lisanslı bir ödeme kuruluşunun altyapısı üzerinden alınır. Otomatik yenileme, Kullanıcı tarafından panelden açılıp kapatılabilir.',
        ],
      },
      {
        h: '4. İptal ve Cayma',
        p: [
          'Kullanıcı aboneliğini panelden dilediği zaman iptal edebilir. İptal, içinde bulunulan ödeme döneminin sonunda geçerli olur; o döneme kadar hizmet devam eder, taahhüt yoktur.',
          'Vokelle bir dijital hizmettir ve hizmetin ifasına abonelik başladığı anda başlanır. Mesafeli Sözleşmeler Yönetmeliği m.15/1-(ğ) uyarınca, ifasına başlanan hizmetlerde cayma hakkı kullanılamaz; Kullanıcı satın alma sırasında bunu kabul eder.',
          'Teknik bir nedenle hizmetin ilgili dönemde hiç sunulamaması hâlinde, o döneme ait ücret iade edilir veya abonelik süresi eşdeğer kadar uzatılır.',
        ],
      },
      {
        h: '5. Kabul Edilebilir Kullanım',
        p: ['Kullanıcı:'],
        list: [
          'Hizmeti yalnızca kendisine ait veya yönetmeye yetkili olduğu bir sunucuyu izlemek için kullanır,',
          'Vokelle ajanını yalnızca erişim yetkisine sahip olduğu bir veritabanına bağlar,',
          'Yazılımı tersine mühendisliğe tabi tutmaz, hizmete yetkisiz erişim veya hizmeti aksatma girişiminde bulunmaz,',
          'Hizmeti hukuka aykırı bir amaçla kullanmaz.',
        ],
      },
      {
        h: '6. Fikri Mülkiyet',
        p: [
          'Vokelle yazılımı, kaynak kodu, arayüzü, tasarımı, markası ve içeriği VokerStudio\'ya aittir ve fikri mülkiyet hakları saklıdır. Bu koşullar Kullanıcıya, hizmeti kullanım süresiyle sınırlı, devredilemez bir kullanım hakkı tanır.',
        ],
      },
      {
        h: '7. Sorumluluğun Sınırlanması',
        p: [
          'Vokelle bir erken uyarı aracıdır; her anomaliyi yakalayacağına dair bir garanti vermez ve tespitlerin eksiksiz veya kesin olduğunu taahhüt etmez.',
          'VokerStudio; hizmet kesintileri, gecikmeler, yanlış ya da eksik uyarılar veya bunların doğurabileceği sonuçlardan (oyuncu kaybı, ekonomik zarar, itibar kaybı vb.) sorumlu tutulamaz. VokerStudio\'nun her hâlükârda toplam sorumluluğu, Kullanıcının uyuşmazlık tarihinden önceki 3 ay içinde ödediği tutarla sınırlıdır.',
        ],
      },
      {
        h: '8. Veri ve Gizlilik',
        p: [
          'Gizlilik Politikası ve KVKK Aydınlatma Metni bu Kullanım Koşullarının ayrılmaz bir parçasıdır.',
        ],
      },
      {
        h: '9. Değişiklikler ve Fesih',
        p: [
          'VokerStudio bu koşulları güncelleyebilir; önemli değişiklikler Kullanıcıya bildirilir ve hizmeti kullanmaya devam etmek güncel koşulların kabulü anlamına gelir. Kullanıcının koşulları ihlali hâlinde VokerStudio hesabı veya lisansı askıya alabilir ya da sonlandırabilir.',
        ],
      },
      {
        h: '10. Uygulanacak Hukuk ve İletişim',
        p: [
          'Bu koşullara Türk hukuku uygulanır; İstanbul (Anadolu) mahkemeleri ve icra daireleri yetkilidir.',
          `İletişim: ${CONTACT}`,
        ],
      },
    ],
  },

  kvkk: {
    title: 'KVKK Aydınlatma Metni',
    updated: UPDATED,
    intro:
      '6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") m.10 kapsamında, Vokelle hizmeti aracılığıyla işlenen kişisel verilerinize ilişkin aydınlatma yükümlülüğümüzü yerine getirmek amacıyla hazırlanmıştır.',
    sections: [
      {
        h: '1. Veri Sorumlusu',
        p: [
          `Veri sorumlusu, Vokelle hizmetini işleten VokerStudio\'dur. İletişim: info@vokelle.com — https://vokelle.com`,
        ],
      },
      {
        h: '2. İşlenen Kişisel Veriler',
        list: [
          'Kimlik ve İletişim: e-posta adresi, görünen ad',
          'İşlem Güvenliği: şifre (özet/hash biçiminde), IP adresi, giriş kayıtları, tarayıcı bilgisi',
          'Müşteri İşlem: abonelik ve ödeme kayıtları, lisans anahtarı',
          'Pazarlama/İletişim: Kullanıcının eklediği bildirim kanalı bilgileri (Discord/Telegram/e-posta)',
        ],
        p: [
          'Not: Vokelle ajanı, oyun sunucunuzdan yalnızca toplu, sayısal göstergeler alır. Oyunculara ait kişisel veriler (isim, şifre, e-posta, sohbet, işlem detayı) Vokelle sistemlerine aktarılmaz.',
          'İsteğe bağlı "Reklam ölçümü" özelliği yalnızca sunucu sahibi tarafından açıldığında: yeni oyun hesaplarının kayıt IP adresi geri döndürülemez biçimde şifrelenmiş (hash) olarak işlenir, ham IP saklanmaz, 90 gün içinde silinir (bkz. Gizlilik Politikası m.10).',
        ],
      },
      {
        h: '3. Kişisel Verilerin İşlenme Amaçları',
        list: [
          'Hizmetin sunulması, sürdürülmesi ve iyileştirilmesi',
          'Abonelik ve ödeme süreçlerinin yürütülmesi',
          'Anomali tespiti ve bildirim gönderilmesi',
          'Teknik destek ve talep/şikâyet yönetimi',
          'Bilgi güvenliği süreçlerinin yürütülmesi',
          'Hukuki yükümlülüklerin yerine getirilmesi',
        ],
      },
      {
        h: '4. Hukuki Sebepler',
        p: [
          'Verileriniz; bir sözleşmenin kurulması veya ifası için gerekli olması (KVKK m.5/2-c), hukuki yükümlülüğün yerine getirilmesi (m.5/2-ç), bir hakkın tesisi/kullanılması/korunması (m.5/2-e) ve veri sorumlusunun meşru menfaati (m.5/2-f) hukuki sebeplerine dayanılarak işlenir. Bu sebeplerin bulunmadığı hâllerde açık rızanıza (m.5/1) dayanılır.',
        ],
      },
      {
        h: '5. Toplama Yöntemi',
        p: [
          'Kişisel verileriniz; web sitesi ve panel üzerinden elektronik ortamda, ödeme altyapısı aracılığıyla ve Vokelle ajanının gönderdiği teknik raporlar aracılığıyla toplanır.',
        ],
      },
      {
        h: '6. Aktarım',
        p: [
          'Kişisel verileriniz kural olarak yurt içinde tutulur ve üçüncü kişilere aktarılmaz. Zorunlu hâllerde; ödeme kuruluşu, e-posta ve barındırma hizmeti sağlayıcıları ile yetkili kamu kurum ve kuruluşlarına, KVKK m.8 ve m.9\'da öngörülen şartlara uygun olarak aktarılabilir.',
        ],
      },
      {
        h: '7. Saklama Süresi',
        p: [
          'Kişisel verileriniz, ilgili mevzuatta öngörülen süreler boyunca; mevzuatta bir süre öngörülmemişse işleme amacının gerektirdiği süre boyunca saklanır. Süre sonunda verileriniz silinir, yok edilir veya anonim hâle getirilir.',
        ],
      },
      {
        h: '8. İlgili Kişinin Hakları',
        p: ['KVKK m.11 uyarınca her zaman veri sorumlusuna başvurarak:'],
        list: [
          'Kişisel verinizin işlenip işlenmediğini öğrenme, işlenmişse buna ilişkin bilgi talep etme',
          'İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme',
          'Yurt içinde veya yurt dışında verilerin aktarıldığı üçüncü kişileri bilme',
          'Eksik veya yanlış işlenmiş verilerin düzeltilmesini isteme',
          'KVKK m.7\'deki şartlar çerçevesinde silinmesini veya yok edilmesini isteme',
          'Düzeltme, silme ve yok etme işlemlerinin aktarıldığı üçüncü kişilere bildirilmesini isteme',
          'Münhasıran otomatik sistemlerle analiz sonucu aleyhe bir sonucun ortaya çıkmasına itiraz etme',
          'Kanuna aykırı işleme sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme',
          'haklarına sahipsiniz.',
        ],
      },
      {
        h: '9. Başvuru',
        p: [
          'Yukarıdaki haklarınıza ilişkin taleplerinizi info@vokelle.com adresine iletebilir veya Kişisel Verileri Koruma Kurulu\'nun belirlediği diğer yöntemlerle başvuruda bulunabilirsiniz. Başvurularınız, talebin niteliğine göre en geç 30 gün içinde sonuçlandırılır.',
        ],
      },
    ],
  },
};
